import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from '@firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyACcKo8edDdvvyZDPQ0ovL7FYgi25waa30",
  authDomain: "portfolio-53429.firebaseapp.com",
  projectId: "portfolio-53429",
  storageBucket: "portfolio-53429.appspot.com",
  messagingSenderId: "866839969946",
  appId: "1:866839969946:web:fda4e8b2902b38ae369f23",
  measurementId: "G-TRSR4ZV74M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getFirestore(app);
